module.exports = __webpack_public_path__ + "img/general-1.50133570.png";